import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';
import { LogoSpinnerComponent } from "../../lib/spinner/spinnerLogo";
import { ActiveIcon } from "../../ui/icons/activeIcon";
import { EditIcon } from "../../ui/icons/edit";
import { InactiveIcon } from "../../ui/icons/inactiveIcon";
import { TrashIcon } from "../../ui/icons/trash";
import { Dropdown } from "../../ui/organisms/dropdown";
import { formatterDate } from "../../utils";
import { GetBusinessTechnicianById, removeBusinessTechnician } from "./slice";


export function ListBusinessTech() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const businessTechinician = useAppSelector(state => state.businessTechinician)

    if (businessTechinician.businessTechinicianResponseStatus === 'loading') {
        return (
            <LogoSpinnerComponent fullScreen />
        )
    }

    return (
        <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
            <table id="customers-table" className="w-full border-collapse text-text-sm">
                <thead>
                    <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Nominativo</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Fiscale</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">P.IVA</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Ingresso</th>
                        <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Uscita</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap">Status</th>
                        <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                    </tr>
                </thead>
                <tbody>
                    {businessTechinician.businessTechinicianResponse?.data.map((tech, rowIndex) =>
                        <tr
                            key={tech.id}
                            className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${rowIndex % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                        >
                            <td className="px-3 py-2 text-blue-800 font-bold text-left whitespace-nowrap">
                                {tech.companyName}
                            </td>
                            <td className="px-3 py-2 text-neutral-700 font-semibold whitespace-nowrap">
                                {tech.fiscalCode}
                            </td>
                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap font-mono">
                                {tech.vat}
                            </td>
                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                {tech.countryRegion}
                            </td>
                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                {formatterDate(tech.activationDate)}
                            </td>
                            <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                {tech.deactivationDate ? formatterDate(tech.deactivationDate) : <span className="text-neutral-400">-</span>}
                            </td>
                            <td className="px-3 py-2 text-center">
                                {
                                    !tech.deactivationDate ?
                                        (
                                            <ActiveIcon></ActiveIcon>
                                        )
                                        :
                                        (
                                            <InactiveIcon></InactiveIcon>
                                        )
                                }
                            </td>
                            <td className="px-3 py-2 w-[60px] cursor-pointer">
                                <div className="d-flex justify-content-between align-items-center" style={{ cursor: "pointer" }}>
                                    {
                                        tech.active ?
                                            <Dropdown
                                                portaled
                                                items={[
                                                    {
                                                        label: 'Modifica',
                                                        icon: <EditIcon color={""} size={0} />,
                                                        onClick: () => {
                                                            dispatch(GetBusinessTechnicianById(tech.id))
                                                            navigate('/editTecnicoAziendale/' + tech.id)
                                                        }

                                                    },
                                                    {
                                                        label: 'Disattiva',
                                                        icon: <TrashIcon color={""} size={0} />,
                                                        onClick: () => {
                                                            dispatch(removeBusinessTechnician(tech.id))
                                                        }
                                                    }

                                                ]}
                                            />
                                            : <Dropdown
                                                portaled
                                                items={[
                                                    {
                                                        label: 'Modifica',
                                                        icon: <EditIcon color={""} size={0} />,
                                                        onClick: () => {
                                                            dispatch(GetBusinessTechnicianById(tech.id))
                                                            navigate('/editTecnicoAziendale/' + tech.id)
                                                        }

                                                    }

                                                ]}
                                            />
                                    }
                                </div>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    )
}